module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Settings4-27b63684931196ea492dae4e0e74f9e3.svg";